import React from "react";
import { Category } from "../types";
import { Button } from "../components/Button";

interface CategoriesSettingsSectionProps {
  categories?: Category[];
  onAddCategory: () => void;
  onEditCategory: (category: Category) => void;
}

export const CategoriesSettingsSection: React.FC<CategoriesSettingsSectionProps> = ({
  categories,
  onAddCategory,
  onEditCategory,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ margin: 0 }}>Categories</h3>
        <Button size="sm" onClick={onAddCategory}>
          Add Category
        </Button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
        {categories?.map((category, index) => (
          <div
            key={category.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              margin: "0 -16px",
              backgroundColor: "#fff",
              borderTop: index === 0 ? "0.5px solid #ccc" : "none",
              borderBottom: "0.5px solid #ccc",
            }}
          >
            <span>{category.name}</span>
            <Button
              size="sm"
              variant="outline"
              onClick={() => onEditCategory(category)}
            >
              Edit
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};